module.exports = __webpack_public_path__ + "img/AtaMuhammad-Bexud.f91ba872.jpg";